<template>
  <div class="lib">
    <div class="container lib-container" v-cloak>
      <div class="title">{{ category?.name || 'Категории' }}</div>
      <div v-if="category?.description" class="description">
        {{ category?.description }}
      </div>
      <div class="lib-wrap">
        <router-link
          v-for="lib in libs"
          :key="lib.id"
          :to="`/category/${lib.id}`"
          class="lib-item"
        >
          <div class="lib-item-title">{{ lib.name }}</div>
        </router-link>
        <ObserverBlock @intersect="intersected" />
      </div>
      <PageLoader v-show="pageLoaderShow" />
    </div>
  </div>
</template>

<script>
import { getCategory, getCategories } from '@/functions/API';
import ObserverBlock from '@/components/blocks/observer/ObserverBlock.vue';
import PageLoader from '@/components/blocks/loader/PageLoader.vue';

export default {
  name: 'CategoryBlock',
  components: {
    ObserverBlock,
    PageLoader,
  },
  data() {
    return {
      category: null,
      libs: [],
      inlineLoaderShow: true,
      page: 0,
      endContent: false,
    };
  },
  watch: {
    $route() {
      this.libs = [];
      this.inlineLoaderShow = true;
      this.page = 0;
      this.endContent = false;
      this.getData();
    },
  },
  mounted() {
    if (this.page == 0) {
      this.inlineLoaderShow = true;
      this.page += 1;
      this.getData();
    }
  },
  methods: {
    getData() {
      var categoryId = this.$route.params.id || null;
      if (categoryId) {
        getCategory(categoryId, (res) => {
          if (res !== false) {
            this.category = res;
          }
        });
      }
      getCategories(this.page, categoryId, (res) => {
        if (res !== false) {
          const resCategories = res?.data;
          if (resCategories.length > 0) {
            if (this.libs.length > 0) {
              this.libs = this.libs.concat(resCategories);
            } else {
              this.libs = resCategories;
            }
            this.inlineLoaderShow = false;
          } else {
            this.endContent = true;
            this.inlineLoaderShow = false;
          }
          this.pageLoaderShow = false;
        }
      });
    },
    intersected() {
      if (!this.endContent) {
        this.inlineLoaderShow = true;
        this.page += 1;
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lib {
  margin-top: 16px;
  margin-bottom: 16px;
  &-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  .title {
    color: var(--color-black);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
  }
  .description {
    color: var(--color-black);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
  }
  &-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  &-item {
    width: calc(50% - 6px);
    height: 160px;
    border-radius: 12px;
    background: linear-gradient(
      245deg,
      #004996 5.49%,
      #0e58a5 47.68%,
      #4898ec 109.01%
    );
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    &-title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      position: relative;
      z-index: 1;
      padding: 16px;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 125%;
    }
  }
}
</style>
